import { memo } from 'react';
import NextImage from 'next/image';

import { HeaderBottomBlockWrapper } from './styles';
import Text from '../common/text';
import useTriggerFunnelyticsEvent from 'hooks/useTriggerFunnelyticsEvent';
import { GENERIC_EVENTS } from 'hooks/useTriggerFunnelyticsEvent/constants';

function HeaderBottomBlock() {
  const { createEventTriggerer } = useTriggerFunnelyticsEvent();

  return (
    <HeaderBottomBlockWrapper>
      <a
        href="tel:+18449574247"
        onClick={createEventTriggerer({
          eventName: GENERIC_EVENTS.CALL_EXPERT,
          withPathname: true,
          ctaPosition: 'floating-mobile-cta',
        })}
      >
        <NextImage
          src="/static/icons/phone-green.svg"
          alt="Phone Icon"
          priority
          width={24}
          height={24}
        />
        <Text fw="medium" type="mode9">
          +1844-957-4247
        </Text>
      </a>
    </HeaderBottomBlockWrapper>
  );
}

export default memo(HeaderBottomBlock);
